<h1>PROGRAM</h1>
<h2>September 25th</h2>
<table class="orari" cellspacing="2" cellpadding="2" id="25morning">
	<th class="schedule" colspan="2">
		<font size="+1">
			<b> September 25th (morning) - Institutional Session</b>
			<br>
			<i class="location">Centro D. Menichella, Largo Guido Carli 1, Frascati (Rome)</i>
		</font>
		<br>
		<i style="color: var(--cifris_scarlet);">All talks in the institutional session are held in Italian</i>
	</th>
	<tr>
		<td class="schedule" style="width: 100px;"> 10:00<br>10:30 </td>
		<td><em> Registration </em></td>
	</tr>
	<tr>
		<td class="schedule"> 10:30<br>11:00 </td>
		<td>
			<i>Welcome address</i>
			<div class="disclaimer-box">
				<i class="disclaimer">in Italian</i>
			</div>
			<ul>
				<li><b class="invited-speaker">Alessandra Perrazzelli</b>, Vicedirettrice Generale (Banca d'Italia)</li>
				<li><b class="invited-speaker">Massimiliano Sala</b>, Presidente (De Componendis Cifris)</li>
			</ul>
		</td>
	</tr>
	<tr>
		<td class="schedule"> 11:00<br>11:30 </td>
		<td>
			<i>Institutional round table</i>
			<div class="disclaimer-box">
				<i class="disclaimer">in Italian</i>
			</div>
			Moderator:
			<ul>
				<li><b class="invited-speaker">Luigi Bellomarini</b>, Capo della Divisione Ricerca sulle Tecnologie Avanzate (Banca d'Italia)</li>
			</ul>
			Speakers:
			<ul>
				<li><b class="invited-speaker">Marco Mattiucci</b>, Direttore della Direzione di Telematica C.G. (Arma dei Carabinieri)</li>
				<li><b class="invited-speaker">Luca G. Cioffi</b>, Capo Ufficio Analisi (Guardia di Finanza)</li>
				<li><b class="invited-speaker">Andrea Billet</b>, Direttore Servizio Certificazione e Vigilanza (ACN)</li>
				<li><b class="invited-speaker">Santo Mirabelli</b>, Direttore 5a Divisione Tecnica del Servizio Polizia Postale (Ministero degli Interni)</li>
			</ul>
		</td>
	</tr>
	<tr>
		<td class="schedule"> 11:30<br>12:00 </td>
		<td><em> Coffee break </em></td>
	</tr>
	<tr>
		<td class="schedule"> 12:00<br>12:30 </td>
		<td>
			Invited Talk
			<div class="disclaimer-box">
				<i class="disclaimer">in Italian</i>
			</div>
			<ul>
				<li><i>La De Cifris e la crittografia italiana</i></li>
				<li><b class="invited-speaker">Barbara Masucci</b>, University of Salerno (Italy)</li>
			</ul>
		</td>
	</tr>
	<tr>
		<td class="schedule"> 12:30<br>13:00 </td>
		<td>
			<i>De Cifris Partners</i>
			<div class="disclaimer-box">
				<i class="disclaimer">in Italian</i>
			</div>
			<ul>
				<li><b class="invited-speaker">Chiara Ballari</b>, <a href="https://www.athilab.eu/">Athilab</a></li>
				<li><b class="invited-speaker">Massimo Caccia</b>, <a href="https://www.randompower.eu/">Random Power</a></li>
				<li><b class="invited-speaker">Simone Capeleto</b>, <a href="https://www.thinkquantum.com/">ThinkQuantum</a></li>
				<li><b class="invited-speaker">Alessandra Matteis</b>, <a href="https://www.qticompany.com/">QTI SRL</a></li>
				<li><b class="invited-speaker">Andrea D'Intino</b>, <a href="https://forkbomb.solutions/">FORKBOMB BV</a></li>
			</ul>
		</td>
	</tr>
	<tr>
		<td class="schedule">13:00<br>14:00</td>
		<td><em> Lunch </em></td>
	</tr>
</table>